var React = require('react');

function SignalUnknown (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("path",{"d":"M1.424 19.1h3v-3h-3v3zm5 0h3v-7h-3v7zm5 0h3v-12h-3v12zm5 0h3v-18h-3v18z","opacity":".5","key":0}),React.createElement("path",{"d":"M4.374 10.1h-1.9V8.2h1.9v1.9zm.68-4.55c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94a1.498 1.498 0 0 0-1.06-2.56c-.83 0-1.5.67-1.5 1.5h-1.5c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69-.375.436-.38.42-.67.71z","key":1})]));
}

SignalUnknown.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = SignalUnknown;

SignalUnknown.default = SignalUnknown;
